import React, { Component } from 'react';
import PopUpSelect from './PopUpSelect';

class Button extends Component {
	constructor(props) {
		super(props);
		this.state = {
			displayPopUp: false,
			popUpStyle: Object.assign({ display: 'none' }, this.props.popUpStyle),
			left: 0,
			top: 0,
			bottom: 0,
			displayItem: null,
			displayItemKey: null,
			newStateKey: '',
			isAlreadyUpdated: false
		};
		let handleChangeItemState = this.handleChangeItemState.bind(this);
		this.setPopUpRef = this.setPopUpRef.bind(this);
		this.setButtonRef = this.setButtonRef.bind(this);
	};

	componentWillMount() {
		this.setState({
			isAlreadyUpdated: false,
		})

		if (this.props.buttonType == 'multiState' || this.props.buttonType == 'multiStateIcon') {
			if (this.props.defaultItemKey != null) {
				let items = this.props.item;
				let itemLength = items.length;
				let key = this.props.defaultItemKey;

				for (var i = 0; i < itemLength; i++) {
					if (items[i].key == key) {
						this.setState({
							displayItem: items[i].display,
						});
						break;
					}
				}
			} else {
				this.setState({
					displayItem: this.props.item[0].display,
					newStateKey: this.props.newStateKey
				})
			}
		}

		if (this.props.left != null || this.props.top != null || this.props.bottom) {
			this.setState({
				left: this.props.left,
				top: this.props.top,
				bottom: this.props.bottom,
			});
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleOnClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleOnClickOutside);
	}

	handleOnClickOutside = (event) => {
		if (this.PopUpRef && !this.PopUpRef.contains(event.target)
			&& this.ButtonRef && !this.ButtonRef.contains(event.target)) {
			if (this.props.buttonType == 'multiState' || this.props.buttonType == 'multiStateIcon') {
				if (this.state.popUpStyle.display == 'block') {
					let temp = this.state.popUpStyle;
					temp.display = 'none';
					this.setState({
						popUpStyle: temp,
						displayPopUp: false,
					});
				}
			}
		}
	}

	/**
	* Set the wrapper ref
	*/
	setPopUpRef(node) {
		this.PopUpRef = node;
	}

	setButtonRef(node) {
		this.ButtonRef = node;
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.newStateKey != this.state.newStateKey) {
			let temp = this.state.popUpStyle;
			temp.display = 'none'
			this.setState({
				displayPopUp: true,
				popUpStyle: temp,
				newStateKey: this.props.newStateKey
			});

			return true;
		}
		else if (nextProps.popUpStyle != nextState.popUpStyle) {
			return true;
		} else if (nextProps.defaultItemKey != nextState.displayItemKey) {
			return true;
		}
	}

	handleOnClick = (e) => {
		let button_id = '';
		if (this.props.id == null || this.props.id == undefined) button_id = '';
		else button_id = this.props.id
		document.getElementById('component_button_' + button_id).classList.add('fadeIn');
		setTimeout(() => {
			if (document.getElementById('component_button_' + button_id) != null) {
				document.getElementById('component_button_' + button_id).classList.remove('fadeIn');
				if (this.props.longPress != null) {
					this.props.longPress();
					return;
				}
				let element = this.refs.btn.getClientRects();
				if (this.props.onClick != null) {
					this.props.onClick();
					return;
				}
				else if (this.props.buttonType == 'multiState' || this.props.buttonType == 'multiStateIcon') {
					let isDisplayPopup = this.state.displayPopUp;
					if (this.props.left != null || this.props.top != null || this.props.bottom) {
						this.setState({
							displayPopUp: !isDisplayPopup,
							left: this.props.left,
							top: this.props.top,
							bottom: this.props.bottom,
						}, () => {
							let temp = this.state.popUpStyle;
							if (temp.display != 'none') {
								temp.display = 'none'
								this.setState({
									popUpStyle: temp,
								})
							} else {
								temp.display = 'block';
								this.setState({
									popUpStyle: temp,
								})
							}
						});
					} else {
						this.setState({
							displayPopUp: !isDisplayPopup,
							left: element["0"]["width"] + 10,
							top: -(element["0"]["height"] + 10),
						}, () => {
							let temp = this.state.popUpStyle;
							if (this.state.displayPopUp) {
								temp.display = 'none'
								this.setState({
									popUpStyle: temp,
								})
							} else {
								temp.display = 'block';
								this.setState({
									popUpStyle: temp,
								})
							}
						});
					}
				} else if (this.props.buttonType == 'icon') {
					if (this.props.GetIconButton != null) {
						this.props.GetIconButton();
					}
				}
			}
		}, 300);
	}

	handleOnMouseUp = (event) => {
		if (this.props.onMouseUp != null) {
			this.props.onMouseUp();
		} else {
			this.handleOnClick();
		}
	}

	handleChangeItemState = (key) => {
		if (this.props.changeDefaultItemKey != null) {
			this.props.changeDefaultItemKey();
		}

		if (this.props.handleChangeIcon != null) {
			this.props.handleChangeIcon(key);
		}

		let items = this.props.item;
		let itemLength = items.length;
		let index = -1;

		for (var i = 0; i < itemLength; i++) {
			if (items[i].key == key) {
				this.setState({
					displayItem: items[i].display,
					displayItemKey: items[i].key,
				});
				break;
			}
		}

		let temp = this.state.popUpStyle;
		temp.display = 'none';

		this.setState({
			popUpStyle: temp,
			displayPopUp: true,
		})

		if (this.props.handleChangeItem != null) {
			this.props.handleChangeItem(key);
		}
	}


	render() {
		let style = {};

		let buttonStyle = {
			fontFamily: 'Myriad-light',
			backgroundColor: this.props.bgColor,
			outline: 'none',
			margin: 10,
			padding: '5px 16px',
			minWidth: 64,
			minHeight: 45,
			border: 0,
			boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
			fontSize: '0.875rem',
			fontWeight: '600',
			borderRadius: '6px',
			color: 'white',
			cursor: 'pointer',
			opacity: 1,

		}

		let disabledStyle = {
			fontFamily: 'Myriad-light',
			backgroundColor: '#eeeeee',
			margin: 10,
			padding: '5px 16px',
			minWidth: 64,
			minHeight: 45,
			border: 0,
			boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
			fontSize: '0.875rem',
			fontWeight: '600',
			borderRadius: '6px',
			color: '#15141482',
			cursor: 'pointer',
			opacity: 0.9,
		}

		if (this.props.buttonType == 'icon') {
			buttonStyle.backgroundColor = this.props.bgColor == null ? 'inherit' : this.props.bgColor;
			buttonStyle.outline = 'none';
			disabledStyle.backgroundColor = 'none';
			disabledStyle.boxShadow = 'none';
			disabledStyle.outline = 'none';
		} else if (this.props.buttonType == 'circle') {
			buttonStyle.borderRadius = '50%';
			buttonStyle.width = 60;
			buttonStyle.height = 60;
			buttonStyle.outline = 'none';
			buttonStyle.textAlign = 'center';
			disabledStyle.backgroundColor = 'none';
			disabledStyle.outline = 'none';
			disabledStyle.borderRadius = '50%';
			disabledStyle.width = 60;
			disabledStyle.height = 60;
			disabledStyle.outline = 'none';
			disabledStyle.textAlign = 'center';
		}

		style = Object.assign(style, this.props.style);
		buttonStyle = Object.assign(buttonStyle, this.props.style);
		var handleChangeItemState = this.handleChangeItemState;
		var GetIconButton = this.props.GetIconButton;

		var ButtonDisplay = (props) => {
			const buttonType = props.buttonType;

			if (buttonType == 'multiState') {
				return <div>{this.state.displayItem}</div>
			} else if (buttonType == 'multiStateIcon') {
				if (this.props.defaultItemKey != null) {
					if (this.props.defaultItemKey == 'none') {
						return <div><img src={{}} alt="" style={{ width: '50px' }} /></div>
					}

					let items = this.props.item;
					let itemLength = items.length;
					let index = -1;
					let icon = null;

					for (var i = 0; i < itemLength; i++) {
						if (items[i].key == this.props.defaultItemKey) {
							icon = items[i].display;
							break;
						}
					}

					return <div><img src={icon} alt="" style={{ width: '50px' }} /></div>
				}
				else {
					return <div><img src={this.state.displayItem} alt="" style={{ width: '50px' }} /></div>
				}
			}
			else return null;
		}

		let button_id = '';
		if (this.props.id == null || this.props.id == undefined) button_id = '';
		else button_id = this.props.id

		return (
			<div style={style} id={'button' + this.props.id}>
				<div ref={this.setButtonRef} style={{ width: this.props.disabled == 'disabled' ? disabledStyle.width : buttonStyle.width }}>
					<button ref="btn"
						id={'component_button_' + button_id}
						disabled={this.props.disabled}
						type={this.props.buttonType}
						style={this.props.disabled == 'disabled' ? disabledStyle : buttonStyle}
						onClick={(event) => this.handleOnClick(event)}
					>
						<ButtonDisplay buttonType={this.props.buttonType} />
						{this.props.children}
					</button>
				</div>
				{this.props.buttonType == 'multiState' || this.props.buttonType == 'multiStateIcon' ? (
					<div ref={this.setPopUpRef}>
						<PopUpSelect
							isPopUp={true}
							propType={this.props.buttonType}
							handleChangeItemState={this.handleChangeItemState}
							left={this.state.left}
							top={this.state.top}
							bottom={this.state.bottom}
							style={this.state.popUpStyle}
							bgColor={this.state.popUpStyle.backgroundColor}
							item={this.props.item}>
						</PopUpSelect>
					</div>
				) : null}
			</div>
		);
	}
}

export default Button;